import { Button, Form, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { FormInstance } from 'antd';
import type { SceneEvent } from '@/apis/simulation';
import { EventItemEditor } from './EventItemEditor';

const { Text } = Typography;

export interface EventListEditorProps {
  /**
   * 外部 form 实例。组件不自己 useForm：既挂在 SceneBosFiles 编辑表单上，
   * 也为二阶段 F1 SaveAsModal 复用预留（plan §3.2/§4.2）。
   * Form.List 通过外层 <Form> 上下文绑定该 form；EventItemEditor 的 Form.useWatch
   * 通过显式 form 参数读取 store。
   */
  form: FormInstance;
}

/** 每次添加事件生成全新对象，避免 rc-field-form 复用引用导致多行联动脏写。 */
const createNewEvent = (): SceneEvent => ({
  trigger: { type: 'time' },
  mode: 'once',
  count: 1,
  action: { type: 'cloud_control', cloudCmd: 'DETOUR_LEFT' },
});

/**
 * 云端控制事件列表编辑器：antd <Form.List name="events"> 容器，挂在外层 <Form> 内。
 * 提供添加 / 删除行 + 空状态提示；单行渲染与校验委托给 EventItemEditor（plan §3.2）。
 */
export function EventListEditor({ form }: EventListEditorProps) {
  return (
    <Form.List name="events">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field) => (
            <EventItemEditor
              key={field.key}
              field={field}
              form={form}
              onRemove={() => remove(field.name)}
            />
          ))}
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => add(createNewEvent())}
            style={{ width: '100%' }}
          >
            添加事件
          </Button>
          {fields.length === 0 ? (
            <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>
              未配置云端控制事件（普通场景可不添加）。
            </Text>
          ) : null}
        </>
      )}
    </Form.List>
  );
}

export default EventListEditor;
export { EventItemEditor } from './EventItemEditor';
